import React, { useContext, useEffect } from 'react';
import {Link} from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { ServicesContext } from "../../context/services/servicesContext";
import Loader from '../Loader/Loader';

const MySwal = withReactContent(Swal);

const TablaServices = () => {
    const {data:services,loading,error,find,remove} = useContext(ServicesContext);

    useEffect(() => {
        find();
    }, [])

    const removeService = id=>{
        MySwal.fire({
            title: '¿Desea eliminar el servicio?',
            text: "Esta acción no se puede deshacer",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Eliminar!',
          }).then(async(result) => {
            if (result.value) {
                await remove(id);
                Swal.fire('Listo','El servicio ha sido eliminado','success').then(()=>find());
            }
        })
    }

    if(error){
        Swal.fire('Error',error,'error');
    }

    return (
        loading?<Loader/>:
        <>
            <h3 className="my-4 ml-2">Tabla de administración de servicios</h3>
            <table className="table text-center">
                <thead className="thead-dark">
                <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Servicio</th>
                    <th scope="col" className="text-center">
                        <Link to="/services/new" className="btn btn-outline-info">Agregar</Link>
                    </th>
                </tr>
                </thead>
                <tbody>
                    {services.map(ser=>(
                        <tr key={ser.id}>
                            <td>{ser.id}</td>
                            <td>{ser.name}</td>
                            <td className="text-center">
                                <Link to={{pathname:`/services/edit/${ser.id}`}} className=" ml-2 btn btn-outline-warning">Modificar</Link>
                                <button type="button" onClick={()=>removeService(ser.id)} className=" ml-2 btn btn-outline-danger">Eliminar</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
}
 
export default TablaServices;